const styles = (theme) => ({
  checkbox: {
    padding: '16px',
  },
})

export default styles
